export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "download_detailed_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Descargar detalle de mediciones"])},
          "download_summary_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Descargar resumen de mediciones"])},
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de procesos"])},
          "show_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ver"])}
        }
      },
      "en": {
        "labels": {
          "download_detailed_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Download detailed measurements"])},
          "download_summary_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Download summary measurements"])},
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Go back to process list"])},
          "show_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Show"])}
        }
      }
    }
  })
}